<template>
  <or-layout>
    <a-affix :offsetTop="64">
      <div style="background: #fff; padding-bottom: 24px;">
        <div class="filter-group">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :span="24">
                <label>难度</label>
                <a-rate v-model="searchForm.rate" size="small"></a-rate>
              </a-col>
              <a-col :span="24">
                <label>题型</label>
                <template v-for="tag in questionTypes">
                  <a-checkable-tag :key="tag.id" :checked="selectedQuestionType.indexOf(tag.id) > -1"
                    @change="checked => handleChange(tag.id, checked)">{{ tag.name }}
                  </a-checkable-tag>
                </template>
              </a-col>
              <a-col :span="24">
                <a-form-item>
                  <a-input placeholder="题目编码" v-model="searchForm.node_str"></a-input>
                </a-form-item>
                <a-form-item>
                  <a-input placeholder="关键字" v-model="searchForm.keyword"></a-input>
                </a-form-item>
                <a-form-item>
                  <a-select mode="tags" v-model="searchForm.tag" placeholder="标签" style="width:12rem;">
                    <a-select-option value="常考题">常考题</a-select-option>
                    <a-select-option value="易错题">易错题</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item>
                  <a-tree-select treeNodeFilterProp="title" showSearch class="knowledge"
                    :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }"
                    :treeData="questionNodeList" v-model="searchForm.node_id" placeholder="主知识节点" style="width:12rem;"
                    allowClear></a-tree-select>
                </a-form-item>
                <a-form-item>
                  <a-tree-select treeNodeFilterProp="title" showSearch style="width:12rem;" placeholder="章节信息"
                    v-model="searchForm.chapter_id"
                    :replaceFields="{ children: 'children', title: 'name', key: 'pid', value: 'pid' }"
                    :tree-data="basicChapterList"></a-tree-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <a-divider></a-divider>

        <a-row type="flex" justify="space-between" style="margin-top: 1.5rem;">
          <a-col>
            <!-- <a-radio-group v-model="searchForm.origin" button-style="solid">
                            <a-radio-button>全部题目</a-radio-button>
                            <a-radio-button value="xt">系统题目</a-radio-button>
                            <a-radio-button value="org">机构题目</a-radio-button>
                            <a-radio-button value="my">我的题目</a-radio-button>
                        </a-radio-group> -->
            <a-radio-group v-model="searchForm.subject" button-style="solid">
              <a-radio-button :value="0">全部题目</a-radio-button>
              <a-radio-button :value="1">数学题目</a-radio-button>
              <a-radio-button :value="2">英语题目</a-radio-button>
              <a-radio-button :value="3">语文题目</a-radio-button>
              <a-radio-button :value="4">化学题目</a-radio-button>
              <a-radio-button :value="5">物理题目</a-radio-button>
            </a-radio-group>
            <a-button style="margin-left: 20px;" @click="resetBtn" type="dashed" icon="search">重置
            </a-button>
            <a-button style="margin-left: 20px;" @click="searchBtn" type="primary" icon="search">搜索
            </a-button>

          </a-col>
          <a-col>
            <or-edit-exam-modal :editVisible="editVisible" v-model="exam" @remove="handleRemoveQuestionFormExam"
              @save="handleSaveExam" />
            <or-edit-question-modal @save="questionSave" />
          </a-col>
        </a-row>
      </div>
    </a-affix>

    <div>
      <a-list item-layout="vertical" size="large" :pagination="pageinfo" :data-source="questionList"
        @change="onPaginationChange">
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta>
            <div slot="title">
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'ANSWER'">问答题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VOICE'">语音题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'PREVIEW'">预习题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'JUDGMENT'">判断题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'COMPLETION'">填空题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VIDEO'">口述题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'SINGLE_CHOICE'">单选题
              </a-tag>
              <span style="color: #aeaeae" v-if="item.node_str != ''">[{{ item.node_str }}]</span>
              <div v-html="item.title" />
            </div>
            <template slot="description">
              <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                <a-col :span="6" v-for="option in item.options" :key="option.keys">
                  <div class="option">
                    <label class="label">{{ option.keys }}:</label>
                    <div class="span" v-html="option.value" />
                  </div>
                </a-col>
              </a-row>
              <div>
                <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                <span v-if="item.typestr == 'JUDGMENT' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                <span v-if="item.typestr == 'COMPLETION'">答案(共计{{ item.answer_cnt }}个输入项,其中|符号为分隔符):</span>
                <span v-if="item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">{{ item.answer }}</span>
                <span v-if="item.typestr == 'JUDGMENT' && item.answer == 1">正确</span>
                <span v-if="item.typestr == 'JUDGMENT' && item.answer == 0">错误</span>
              </div>
            </template>
          </a-list-item-meta>
          <div v-if="item.typestr != 'PREVIEW'">
            <h4>解析:</h4>
            <div v-html="item.analysis" />
          </div>
          <a-row type="flex" justify="space-between">
            <div>
              <a-rate :value="item.star"></a-rate>
              <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
              <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
              <a-divider type="vertical" v-if="item.analysisvideo != ''"></a-divider>
              <template v-if="item.systag != 1">
                <a-divider type="vertical" />
                <a-tag color="#2db7f5">相似题</a-tag>
              </template>
              <template v-if="item.analysisvideo != ''">
                <a-divider type="vertical" />
                <or-preview text="解析视频" :videoUrl="item.analysisvideo" />
              </template>
              <template v-if="item.previewvideo != '' && item.typestr == 'PREVIEW'">
                <a-divider type="vertical" />
                <or-preview text="预习视频" :videoUrl="item.previewvideo" />
                <a-divider type="vertical" />
                <span v-if="item.previewvideo_time > 0">时长:
                  {{ Math.floor(item.previewvideo_time / 60) }}分{{ Math.floor(item.previewvideo_time % 60) }}秒</span>
                <span style="color: red;font-weight: bold;font-size: 18px;" v-else>点击 👈 查看预习视频获取时长</span>
              </template>
            </div>
            <div>

              <a @click="similar_pageinfo.current = 1; show_similar_list(item.id)">相似题</a>
              <a-divider type="vertical" />
              <a @click="goQuestioninfo(item.id)">题目分析</a>
              <a-divider type="vertical" />
              <a @click="show_problems_statistics_info(item.id)">统计信息</a>
              <or-edit-question-modal :qid="item.id" button-type="link" button-text="修改" @save="questionSave" />
              <a-popconfirm @confirm="delQuestion({ ids: item.id })" title="你确定要删除吗？">
                <a-button class="remove" type="link">删除</a-button>
              </a-popconfirm>
              <template v-if="isChecked(item)">
                <a-button size="small" type="danger" @click="handleRemoveQuestionFormExam(item)" ghost>移出试卷
                </a-button>
              </template>
              <template v-else>
                <a-button size="small" type="primary" @click="handleAddToExam(item)" ghost>加入试卷
                </a-button>
              </template>
            </div>
          </a-row>
        </a-list-item>
      </a-list>
    </div>
    <a-modal :centered="true" :footer="null" :width="1000" :visible="similar_question_visible" :destroyOnClose="true"
      :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="相似题" okText="相似题" cancelText="关闭"
      @cancel="similar_question_visible = false">
      <a-table :dataSource="similar_list" :rowKey="item => item.similar_question_id" :pagination="similar_pageinfo"
        @change="changeSimilarPage" :loading="loading">
        <a-table-column key="title" title="题目名字">
          <template slot-scope="item">
            <div v-html="item.title"></div>
          </template>
        </a-table-column>
        <a-table-column :width="120" key="del" title="操作">
          <template slot-scope="item">
            <a-button :loading="loading"
              @click="delSimilarQuestion({ question_id: item.question_id, similar_question_id: item.similar_question_id })">
              删除
            </a-button>
          </template>
        </a-table-column>
      </a-table>
      <div style="text-align: right;margin-top: 1rem;">
        <a-button type="primary" @click="search_similar_pageinfo.current = 1; add_similar_question_visible = true">
          添加相似题
        </a-button>
        &nbsp;
        <a-button type="primary" @click="similar_question_visible = false">关闭</a-button>
      </div>
    </a-modal>
    <a-modal :centered="true" :footer="null" :width="600" :visible="problems_statistic_visible" :destroyOnClose="true"
      :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="题目统计"
      @cancel="problems_statistic_visible = false">
      <div class="problems_statistic_main">
        <span class="problems_statistic_title">总题目数:</span><span class="problems_statistic_value">{{
          problems_statistic_info.all_cnt }}</span>
        <a-divider type="vertical" />
        <span class="problems_statistic_title">答题数:</span><span class="problems_statistic_value">{{
          problems_statistic_info.tj_cnt }}</span>
        <a-divider type="vertical" />
        <span class="problems_statistic_title">正确数:</span><span class="problems_statistic_value">{{
          problems_statistic_info.is_right_cnt }}</span>
        <a-divider type="vertical" />
        <span class="problems_statistic_title">错误:</span><span class="problems_statistic_value">{{
          problems_statistic_info.tj_cnt - problems_statistic_info.is_right_cnt }}</span>
        <a-divider type="vertical" />
        <span class="problems_statistic_title">正确率:</span><span class="problems_statistic_value">{{
          problems_statistic_info.is_right_cnt > 0 ? ((problems_statistic_info.is_right_cnt /
            problems_statistic_info.tj_cnt) * 100).toFixed(2) : 0 }}%</span>
      </div>
      <div style="text-align: right;margin-top: 1rem;">
        <a-button type="primary" @click="problems_statistic_visible = false">关闭</a-button>
      </div>
    </a-modal>

    <a-modal :centered="true" :footer="null" :width="1000" :visible="add_similar_question_visible" :destroyOnClose="true"
      :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="添加相似题" @cancel="closeAddSimilarModal">
      <div class="filter-group">
        <a-form layout="inline">
          <a-row :gutter="[16, 8]">
            <a-col :span="24">
              <a-form-item>
                <label>难度</label>
                <a-rate v-model="searchSimilarForm.rate" size="small"></a-rate>
              </a-form-item>
              <a-form-item>
                <a-input placeholder="关键字" v-model="searchSimilarForm.keyword"></a-input>
              </a-form-item>
              <a-form-item>
                <a-tree-select treeNodeFilterProp="title" showSearch class="knowledge"
                  :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }"
                  :treeData="questionNodeList" v-model="searchSimilarForm.node_id" placeholder="主知识节点"
                  style="width:12rem;" allowClear></a-tree-select>
              </a-form-item>
              <a-form-item>
                <a-tree-select treeNodeFilterProp="title" showSearch style="width:12rem;" placeholder="章节信息"
                  v-model="searchSimilarForm.chapter_id"
                  :replaceFields="{ children: 'children', title: 'name', key: 'pid', value: 'pid' }"
                  :tree-data="basicChapterList"></a-tree-select>
              </a-form-item>
              <a-form-item>
                <a-button :loading="loading" type="primary" @click="searchSimilar">搜索</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :dataSource="search_similar_list" :rowKey="item => item.id" :pagination="search_similar_pageinfo"
        @change="changeSearchSimilarPage" :loading="loading">
        <a-table-column key="title" title="题目名字">
          <template slot-scope="item">
            <div v-html="item.title"></div>
          </template>
        </a-table-column>
        <a-table-column :width="120" key="opt" title="操作">
          <template slot-scope="item">
            <a-button :loading="loading" @click="addSimilar(item.id)">添加</a-button>
          </template>
        </a-table-column>
      </a-table>
      <div style="text-align: right;margin-top: 1rem;">
        <a-button type="primary" :loading="loading" @click="closeAddSimilarModal">关闭</a-button>
      </div>
    </a-modal>
  </or-layout>
</template>

<script>
import OrPreview from "@/components/question/preview.vue";
import OrEditExamModal from "@/components/question/edit-exam-modal.vue";
import OrEditQuestionModal from "@/components/question/edit-question-modal.vue";
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {
  data() {
    return {
      //相似题开始
      similar_question_visible: false,
      curr_question_id: undefined,
      similar_list: [],
      add_similar_question_visible: false,
      search_similar_list: [],
      //相似题结束
      questionNodeList: [],
      selectedQuestionType: "",
      problems_statistic_info: {},
      problems_statistic_visible: false,
      questionTypes: [
        {
          id: "ANSWER",
          name: "问答题",
        },
        {
          id: "VIDEO",
          name: "口述题",
        },
        {
          id: "PREVIEW",
          name: "预习题",
        },
        {
          id: "VOICE",
          name: "语音题",

        },
        {
          id: "JUDGMENT",
          name: "判断题",
        },
        {
          id: "COMPLETION",
          name: "填空题",
        },
        {
          id: "SINGLE_CHOICE",
          name: "单选题",
        },
      ],
      listData: [],
      pageinfo: {
        total: 1,
        current: 1,
        pageSize: 10,
        onChange: (page) => this.changePage(page),
      },
      similar_pageinfo: {
        total: 1,
        current: 1,
        pageSize: 5,
        hideOnSinglePage: true
      },
      search_similar_pageinfo: {
        total: 1,
        current: 1,
        pageSize: 5,
        hideOnSinglePage: true
      },

      editVisible: false,
      questionList: [],
      loading: false,
      basicChapterList: [],
      searchForm: {
        node_id: undefined,
        keyword: undefined,
        rate: undefined,
        tag: undefined,
        origin: undefined,
        chapter_id: undefined,
        subject: 0,
      },

      searchSimilarForm: {
        node_id: undefined,
        keyword: undefined,
        rate: undefined,
        chapter_id: undefined
      },
      exam: {
        id: undefined,
        type: undefined,
        name: "",
        start_time: "",
        end_time: "",
        grade_id: undefined,
        semester_id: undefined,
        questions: [],
        teacher_check_flag: 0,
        subject: 1,
        is_newtest: 0,
        banben: 1
      },
    };
  },
  mounted() {
    const examId = this.$route.query.exam;
    if (examId) {
      // 读取试卷信息赋值给 this.exam 包括questions属性
      this.$axios
        .post("/api/QuestionTestpaper/get_testpaper_info", {
          data: { id: examId },
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.exam = res.data;
            this.editVisible = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    this.searchBtn();
    this.getQuestionNodelist();
    this.getBasicChapter();
  },
  methods: {
    show_problems_statistics_info(problems_id) {
      this.problems_statistic_visible = true;
      this.loading = true;
      this.$axios
        .post("/api/QuestionProblems/get_problems_statistics_by_id", {
          data: { problems_id: problems_id },
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
            return false;
          }
          this.problems_statistic_info = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    goQuestioninfo(questioninfoid) {
      let routeData = this.$router.resolve({
        path: '/questionfenxi/' + questioninfoid,
      });
      window.open(routeData.href, '_blank');

    },
    delSimilarQuestion(data) {
      this.loading = true;
      this.$axios
        .post("/api/SimilarQuestion/del_question_similar", {
          data,
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
            return false;
          }
          this.similar_pageinfo.current = 1;
          this.show_similar_list(this.curr_question_id);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closeAddSimilarModal() {
      this.add_similar_question_visible = false;
      this.show_similar_list(this.curr_question_id);
    },
    addSimilar(similar_question_id) {
      this.loading = true;
      this.$axios
        .post("/api/SimilarQuestion/add_question_similar", {
          data: { question_id: this.curr_question_id, similar_question_id: similar_question_id },
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
            return false;
          }
          this.$success({
            title: "成功",
            content: "添加相似题成功",
            okText: "确定",
          });
          return false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    resetBtn() {
      this.searchForm = {
        node_id: undefined,
        keyword: undefined,
        rate: undefined,
        tag: undefined,
        origin: undefined,
        chapter_id: undefined,
        subject: 0,
      };
    },

    searchSimilar() {
      this.loading = true;
      this.$axios
        .post("/api/QuestionProblems/index", {
          data: this.searchSimilarForm,
          pageinfo: this.search_similar_pageinfo,
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
            return false;
          }
          this.search_similar_list = res.data.data;
          this.search_similar_pageinfo = res.data.pageinfo;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeSimilarPage(page) {
      this.similar_pageinfo.current = page.current;
      this.show_similar_list(this.curr_question_id);
    },
    changeSearchSimilarPage(page) {
      this.search_similar_pageinfo.current = page.current;
      this.searchSimilar();
    },

    show_similar_list(id) {
      this.loading = true;
      if (this.curr_question_id != id) {
        this.similar_pageinfo.current = 1;
      }
      this.curr_question_id = id;
      this.$axios
        .post("/api/SimilarQuestion/get_question_similar_list", {
          data: { question_id: id },
          pageinfo: this.similar_pageinfo
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.similar_question_visible = true;
            this.similar_pageinfo = res.data.pageinfo;
            this.similar_list = res.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBasicChapter() {
      if (this.basicChapterList.length == 0) {
        this.$axios
          .post("/api/BasicChapter/gettreeChapter")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.basicChapterList = res.data.series;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    searchBtn() {
      this.searchForm.typestr =
        this.selectedQuestionType == ""
          ? undefined
          : this.selectedQuestionType;
      this.pageinfo.current = 1;
      this.getQuestionList(this.searchForm);
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getQuestionList(this.searchForm);
    },
    //获取知识节点列表
    getQuestionNodelist() {
      if (this.questionNodeList.length == 0) {
        this.$axios
          .post("/api/QuestionNode/index")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.questionNodeList = res.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    changePage(page) {
      this.pageinfo.current = page;
      this.getQuestionList(this.searchForm);
    },
    getQuestionList(data) {
      this.$axios
        .post("/api/QuestionProblems/index", {
          data: data,
          pageinfo: this.pageinfo,
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
            return false;
          }
          this.pageinfo.total = res.data.pageinfo.total;
          this.questionList = res.data.data;
          for (let i = 0; i < this.questionList.length; i++) {
            if (this.questionList[i]["tag"] != "") {
              this.questionList[i]["tag"] = this.questionList[i]["tag"].split(",");
            }
            if (this.questionList[i]["typestr"] == "SINGLE_CHOICE") {
              console.log(this.questionList[i]["options"]);
              this.questionList[i]["options"] = JSON.parse(this.questionList[i]["options"])
            }
          }
        }).catch((err) => {
          console.error(err);
        });
    },
    questionSave() {
      this.searchBtn()
    },
    handleChange(tag, checked) {
      const { selectedQuestionType } = this;
      const nextSelectedTags = checked
        ? [...selectedQuestionType, tag]
        : selectedQuestionType.filter((t) => t !== tag);
      this.selectedQuestionType = nextSelectedTags;
    },
    handleAddToExam(item) {
      this.exam.questions.push(item);
    },
    handleRemoveQuestionFormExam(item) {
      const index = this.exam.questions.indexOf(item);
      this.exam.questions.splice(index, 1);
    },
    isChecked(item) {
      const index = this.exam.questions.indexOf(item);
      return index > -1;
    },
    handleSaveExam() {
      this.exam = {
        name: "",
        type: "",
        start_time: "",
        end_time: "",
        questions: [],
      };
      this.$forceUpdate();
    },
    delQuestion(data) {
      this.$axios
        .post("/api/QuestionProblems/del", { data })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.searchBtn();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  components: { AFormItem, OrEditExamModal, OrEditQuestionModal, OrPreview },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 80rem;
  margin-left: 12rem;
}

.filter-group {
  label {
    font-weight: bold;
    margin-right: 0.5rem;
    text-align: right;
    display: inline-block;
  }
}

.option {
  display: flex;

  .label {
    font-weight: bold;
  }

  .span {
    width: 0;
    flex: 1;
    margin-left: 0.5rem;
  }
}

.remove {
  color: #ff0000;
}

.problems_statistic_main {
  .problems_statistic_title {
    font-size: 16px;
    /*margin-left: 10px;*/
  }

  .problems_statistic_value {
    font-size: 16px;
    font-weight: bold;
    color: red;
  }
}</style>